<template>
  <div class="home">
    <h3>{{ $t('home.title') }}</h3>
    <p>{{ $t('home.description') }}</p>
    <service-list />
  </div>
</template>

<script>
import ServiceList from "./ServiceList";
export default {
    name: 'Home',
    components: {
      ServiceList
    }
}
</script>